import React from 'react';
import { Link } from 'react-router-dom';
import { FaRegCompass } from 'react-icons/fa6';
import { Helmet } from 'react-helmet-async';
import './notFound.css';

function NotFound({ inline = false }) {
    const isLoggedIn = !!localStorage.getItem('token');
    const destination = isLoggedIn ? '/user/dashboard' : '/login';
    const buttonText = isLoggedIn ? 'Go to Dashboard' : 'Back to Login';

    return (
        <>
            <Helmet>
                <title>Page Not Found | Cardplot</title>
                <meta name="description" content="The page you are looking for does not exist on Cardplot. Please check the URL or return to safety." />
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <div className={`notfound__container ${inline ? 'notfound__inline' : ''}`}>
                {!inline && (
                    <>
                        <div className="notfound__blur__circle circle1"></div>
                        <div className="notfound__blur__circle circle2"></div>
                    </>
                )}
                <div className="notfound__card">
                    <div className="notfound__icon__wrapper">
                        <FaRegCompass className="notfound__icon" />
                    </div>
                    <h1 className="notfound__title">404</h1>
                    <p className="notfound__text">
                        The page you are looking for doesn't exist or has been moved. 
                        Let's get you back on track.
                    </p>
                    <Link to={destination} className="notfound__btn">
                        {buttonText}
                    </Link>
                </div>
            </div>
        </>
    );
}

export default NotFound;
